import { useState } from "react";
import { ChartBar } from "@phosphor-icons/react";
import { ASSET_BASE } from "../lib/api";

export function CollegeLogo({ code, hasLogo = true, name, size = 7 }) {
  const [err, setErr] = useState(false);
  const showImg = code && hasLogo && !err;
  const dim = `w-${size} h-${size}`;
  return (
    <span
      className={`${dim} shrink-0 flex items-center justify-center border border-zinc-200 bg-white overflow-hidden`}
      data-testid="college-logo-icon"
    >
      {showImg ? (
        <img
          src={`${ASSET_BASE}/colleges/${code}/logo`}
          alt={`${name || "college"} logo`}
          className="w-full h-full object-contain"
          loading="lazy"
          onError={() => setErr(true)}
        />
      ) : (
        <span
          className="w-full h-full bg-[#6043EF] flex items-center justify-center"
          title="Unicators"
          data-testid="college-logo-fallback"
        >
          <ChartBar size={14} weight="bold" className="text-white" />
        </span>
      )}
    </span>
  );
}
